export default __webpack_public_path__ + "static/media/rafiki.3b801ba6.png";